module.exports = __webpack_public_path__ + "img/icon-gaode.d7790793.png";